import { StepperItem } from '@/types'
import { HiBadgeCheck } from 'react-icons/hi'
import { RxSlash } from 'react-icons/rx'
import { twMerge } from 'tailwind-merge'

interface StepperProps {
  steps: StepperItem[]
  activeStep: string
  className?: string
}

export default function StepperProps({
  steps,
  activeStep,
  className,
}: StepperProps) {
  const displaySteps = steps.filter((step) => !step.hidden)

  return (
    <div
      className={twMerge(
        'py-4 px-6 bg-gray-50 rounded-lg flex-wrap sm:flex-nowrap flex gap-1 justify-start sm:justify-center',
        className
      )}
    >
      {displaySteps.map((step, index) => (
        <div key={index} className="flex items-center gap-1">
          <span
            className={`${activeStep === step.value ? 'font-semibold text-gray-900' : 'text-gray-500'} flex items-center gap-1 leading-tight text-sm`}
          >
            {step.state === 'passed' && <HiBadgeCheck className="w-6 h-6" />}
            {step.label}
          </span>
          {index < displaySteps.length - 1 && (
            <RxSlash className="text-gray-200" />
          )}
        </div>
      ))}
    </div>
  )
}
